// extracted by mini-css-extract-plugin
export var active = "_ez-7";
export var blink = "_ez-8";
export var dropDownSelector = "_ez-4";
export var dropDownWrapper = "_ez-3";
export var fakeCursor = "_ez-6";
export var fontSizeButton = "_ez-9";
export var formQuillEditor = "_ez-0";
export var pressed = "_ez-a";
export var qlBlank = "_ez-1";
export var textFormattingToolbar = "_ez-2";
export var textToolbarOption = "_ez-5";